import { render, staticRenderFns } from "./checkDialog.vue?vue&type=template&id=52c97a2f&scoped=true&lang=html"
import script from "./checkDialog.vue?vue&type=script&lang=js"
export * from "./checkDialog.vue?vue&type=script&lang=js"
import style0 from "./checkDialog.vue?vue&type=style&index=0&id=52c97a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c97a2f",
  null
  
)

export default component.exports